import { ETelemetryType } from './types.js';
export class TelemetryLogger {
    keyTransformer;
    transport;
    constructor(settings) {
        this.keyTransformer = settings.keyTransformer;
        this.transport = settings.transport;
    }
    increment(key, value) {
        this.transport.send({
            key: this.keyTransformer(key),
            type: ETelemetryType.COUNTER,
            value,
        });
    }
    timer(key, value) {
        this.transport.send({
            key: this.keyTransformer(key),
            type: ETelemetryType.TIMER,
            value,
        });
    }
}
//# sourceMappingURL=telemetryLogger.js.map